// Source: updated official paper and previous investor letters dated 31 October 2026.
// Latest paper reports ~50 customers but explicitly leaves payment status unconfirmed.
// Reported figures and proposed plans are not independently verified performance.
export const offerLetterDate = '31 October 2026';
export const founderReportedMetrics = [
  {id:'development', value:'≈ ₹50 lakh', label:'Founder-funded development', note:'Reported development spending, not capital raised in this round.'},
  {id:'revenue', value:'₹1–2 lakh', label:'Previously reported cumulative revenue', note:'Current recurring revenue is unconfirmed. This figure is not ARR.'},
  {id:'customers', value:'≈ 50', label:'Reported customers', note:'The updated paper leaves payment status unconfirmed. This is not a verified paying-customer count.'},
  {id:'prospects', value:'≈ 80', label:'Previously reported prospects', note:'Overlap with the customer count requires verification. Prospects are not contracted sales.'},
];
export const proposedCapitalPlan = [
  {id:'sales',label:'Sales & distribution',amount:70000000},
  {id:'engineering',label:'Engineering & product',amount:50000000},
  {id:'operations',label:'Customer success & operations',amount:20000000},
  {id:'marketing',label:'Marketing & partnerships',amount:20000000},
  {id:'security',label:'Legal, compliance & security',amount:15000000},
  {id:'working-capital',label:'Working capital & contingency',amount:25000000},
];
export const executionMilestones = [
  {period:'0–6 months',title:'Convert and learn',body:'Customer conversion, product-level revenue reporting, reliable onboarding and retention.'},
  {period:'6–18 months',title:'Make execution repeatable',body:'Repeatable sales, integrations, security and operational maturity.'},
  {period:'18–36 months',title:'Scale what works',body:'Expand the strongest products into larger accounts and selected geographies.'},
];
export const operatingScenarios = [
  {year:'2027',milestone:'Foundation',arr:20000000},
  {year:'2028',milestone:'Repeatable sales',arr:100000000},
  {year:'2030',milestone:'Scale',arr:500000000},
  {year:'2032',milestone:'Expansion',arr:1000000000},
  {year:'2034',milestone:'Global platform',arr:2000000000},
];
export const illustrativeMonthlyBurn = 8000000;
export const illustrativeArrMultiple = 10;